import logo from '../assets/logo.svg'
import { Link } from "react-router-dom";
import { useState } from "react";
import authProvider from "../authProvider";
import SpinnerButton from "../components/SpinnerButton.jsx";

export default function Register() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    setLoading(true);
    setError(null);
    event.preventDefault()
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries((formData).entries());
    // TK validate passwords more here... len/special chars/etc
    if (!formJson.password) {
      setError("Password must not be empty.")
      setLoading(false);
      return
    }
    const { error } = await authProvider.register({ email: formJson.email, password: formJson.password });
    if (error) {
      setError(error.message);
      setLoading(false);
      return
    }
  }

  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            alt="Fungistics Logo"
            src={logo}
            className="mx-auto h-10 w-auto"
          />
          <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
            Sign up for Fungistics
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                  Email address
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    autoComplete="email"
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-cyan-800 sm:text-sm/6"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
                  Password
                </label>
                <div className="mt-2">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    required
                    autoComplete="current-password"
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-cyan-800 sm:text-sm/6"
                  />
                </div>
              </div>


              {error &&
                <div className="flex items-center justify-between text-red-500">
                  {error}
                  ERROR
                </div>
              }

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className={`flex w-full justify-center items-center rounded-md px-3 py-1.5 text-sm/6 font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${loading
                    ? "bg-cyan-600 text-gray-200 cursor-not-allowed"
                    : "bg-cyan-800 text-white hover:bg-cyan-600 focus-visible:outline-cyan-800"
                    }`}
                >
                  {loading ? (
                    <SpinnerButton />
                  ) : (
                    "Sign up"
                  )}
                </button>
              </div>
            </form>

          </div>

          <p className="mt-10 text-center text-sm/6 text-gray-500">
            Already have an account?{' '}
            <Link to="/login" className="font-semibold text-cyan-800 hover:text-cyan-600">
              Login here.
            </Link>
          </p>
        </div>
      </div>
    </>
  )
}